/**
 * Where the run's page banner renders, as one predicate.
 *
 * Both Design Studio pages carry `BrandRunPageBanner` above their masthead, so
 * there the app-wide snackbar only covers what the banner leaves to it: a run
 * that is still reading or writing. The snackbar host and the banner's own
 * navigation target read this file so the two can never disagree.
 */

/** TanStack route id for the Styles page, where the wizard acts on a run. */
export const STYLES_ROUTE = '/workspaces/$workspaceId/design-studio/global-styles';

const BANNER_PATH = /^\/workspaces\/\d+\/design-studio\/(global-styles|dashboard)(\/|$)/;
const STYLES_PATH = /^\/workspaces\/\d+\/design-studio\/global-styles(\/|$)/;

/** Whether this path is a Design Studio page that renders the run banner itself. */
export function isBrandRunBannerRoute(pathname: string): boolean {
  return BANNER_PATH.test(pathname);
}

/** Whether this path is the Styles page, where the wizard is mounted to act on the run. */
export function isBrandStylesRoute(pathname: string): boolean {
  return STYLES_PATH.test(pathname);
}
